import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-delete",
  "use": "svg_i-delete-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 18\" id=\"svg_i-delete\"><path d=\"M.995 15.778c0 1.085.896 1.972 1.99 1.972h7.96c1.095 0 1.99-.887 1.99-1.972V3.944H.995v11.834ZM13.93.986h-3.483L9.452 0H4.477l-.995.986H0v1.972h13.93V.986Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol